/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { InputWrapper, IInputCommonProps } from "./InputWrapper";
import { ModelInputText } from "../../shared/model/inputs/ModelInputText";

/**
 * Component props
 */
export interface IInputTextProps extends IInputCommonProps {
	/** Input field */
	input: ModelInputText;

	/** Suffix label, eg. for unit or currency */
	suffix?: string;

	/** Input size */
	size?: number;
}

/**
 * Text field component
 * @param props Props
 */
export function InputText(props: IInputTextProps) {

	const handleInputChange = (ev) => {
		props.input.set(ev.target.value);
	};

	return <InputWrapper {...props} render={(state, baseStyle) => {
		return <>
			<input
				type="text"
				size={props.size}
				onChange={handleInputChange} value={state.inputValue}
			/>
			{props.suffix || state.config.suffix ?
			<span className={baseStyle.el("suffix").className()}>{props.suffix || state.config.suffix}</span>
			: null}
		</>;
	}} />;

}
